import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useGetJobPosts = (jobSeekerId) => {
  const reqUrl = jobSeekerId
    ? `/api/v1/jobPosts?limit=100&page=1&postStatus=active&jobSeekerId=${jobSeekerId}`
    : '/api/v1/jobPosts?limit=100&page=1&postStatus=active';

  const { data, isLoading, error } = useRequest({
    url: reqUrl,
    method: ApiMethodsEnum.Get,
    sendOnStart: true,
  });

  return {
    data,
    isLoading,
    error,
  };
};
